export default `
	headline
	paragraph {
		content
	}
	assetLinkedButton {
		...on AssetLinkedButtonItem {
			asset {
				id
				filename
				size
				url
			}
			heading
			disabled
		}
	}
`;
